<template>
  <div class="rank-container">
    <img
      class="bg-text"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8a339f43cfd0715da7b09c5ce6c7e6b7.png"
      alt=""
    />
    <div class="rank" v-if="coachInfo">
      <div class="v-time">活动时间：1月10日-1月17日</div>
      <div class="rank-before">
        <img
          class="rank-bg"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4e1ec52e9eec4f3557a76df298448575.png"
          alt=""
        />
        <div
          class="rank-item"
          @click="bindClickItem(item)"
          :class="['rank-item-' + index]"
          v-for="(item, index) in beforeList"
          :key="index"
        >
          <div class="item-avatar">
            <img class="item-index" :src="beforeIconList[index].icon" alt="" />
            <img class="item-image" :src="item.c_image" alt="" />
          </div>
          <div class="item-name">{{ item.c_name }}</div>
          <div class="item-num">{{ item.vote_num }}票</div>
          <div class="item-btn-list">
            <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
            <div class="item-btn item-btn-left" @click="bindClickVote(item)"
              >拉票</div
            >
            <div class="item-btn item-btn-right" @click="bindClickVote(item)"
              >投票</div
            >
          </div>
        </div>
      </div>
      <div class="rank-after">
        <div
          class="rank-item"
          v-for="(item, index) in afterList"
          :key="index"
          @click="bindClickItem(item)"
        >
          <div class="item-index">{{ index + 4 }}</div>
          <div class="item-content">
            <img class="item-avatar" :src="item.c_image" alt="" />
            <div class="item-info">
              <div class="item-name">{{ item.c_name }}</div>
              <div class="item-num"
                ><span>{{ item.vote_num }}票</span
                ><span class="item-flag" v-if="item.is_my_coach"
                  >服务过我</span
                ></div
              >
            </div>
            <div class="item-btn-list">
              <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
              <div class="item-btn item-btn-left" @click="bindClickVote(item)"
                >拉票</div
              >
              <div class="item-btn item-btn-right" @click="bindClickVote(item)"
                >投票</div
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc-container">
      <div class="text1">截止2023年底，我们的营养师已经</div>
      <div class="text2"
        >帮助了<span class="pink">53.2万人</span>，成功瘦身<span class="pink"
          >297.8万斤</span
        ></div
      >
    </div>
    <div class="dynamic-content">
      <div class="title">下面是来自学员的真实反馈</div>
      <div class="dynamic-list">
        <div
          class="dynamic-item-container"
          v-for="(item, index) in dynamicList"
          :key="index"
        >
          <DynamicItem class="dynamic-item" :data="item" />
          <WxOpenLaunchApp :extinfo="item.extinfo"></WxOpenLaunchApp>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import DynamicItem from './components/dynamic-item.vue'
import { dynamicList } from './data.js'
export default {
  components: { WxOpenLaunchApp, DynamicItem },
  computed: {
    beforeList() {
      return this.coachInfo.slice(0, 3)
    },
    afterList() {
      return this.coachInfo.slice(3)
    },
    activityId() {
      return this.$route?.query?.activityId || 1
    }
  },
  data() {
    return {
      coachInfo: [],
      dynamicList,
      beforeIconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d0d5fa2630c4ac2fa7fd5f0a3c164745.png'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/47b4c0086f04e815976abf9d79ccc060.png'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7008ec00463930f87fe9daf0ba6eb494.png'
        }
      ],
      extinfo: ''
    }
  },
  created() {
    this.setExtinfo()
    this.getCoachInfo()
  },
  methods: {
    setExtinfo() {
      let url =
        location.origin +
        '/dietitian-vote/index?activityId=' +
        this.$route.query.aid
      this.extinfo = '/web?url=' + url + '&isLogin=1'
      this.dynamicList.map((item) => {
        item.extinfo =
          '/ugcDetails?tabType=' +
          item.detail.tab_type +
          '&id=' +
          item.detail.id
      })
    },
    bindClickItem(item) {
      this.$router.push({
        path: '/dietitian-vote/vote',
        query: {
          cid: item.coach_id,
          uid: this.$route.query.uid,
          aid: this.$route.query.aid
        }
      })
    },
    bindClickVote(item) {},
    async getCoachInfo() {
      let params = {
        activity_id: this.activityId
      }
      let res = await this.$http
        .getApp('api/v1/Vote/getAllCoachInfoForH5', params)
        .catch(() => {
          this.$toast('异常错误')
        })
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.coachInfo = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.rank-container {
  min-height: 100vh;
  overflow: hidden;
  padding: 0px 16px 52px;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/927eacb5c93615d7a0e3795bdc91a7cf.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  background-color: #f3e9ff;
  position: relative;

  .bg-text {
    left: 26px;
    top: 24px;
    position: absolute;
    width: 192px;
    height: 73px;
    z-index: 3;
  }

  .rank {
    margin-top: 100px;
    margin-bottom: 16px;

    .v-time {
      position: relative;
      z-index: 2;
      padding: 0px 16px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: rgba(74, 61, 107, 0.5);
      line-height: 16px;
      margin-bottom: 20px;
    }

    .rank-before {
      height: 183px;
      padding: 0px 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      position: relative;
      z-index: 0;

      .rank-bg {
        position: absolute;
        left: 52%;
        top: 83px;
        transform: translate(-50%, -50%);
        width: 418px;
        height: 418px;
        z-index: -1;
      }

      .rank-item {
        position: absolute;
        width: 109px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .item-avatar {
          position: relative;
          width: 48px;
          height: 48px;
          margin: 0 auto 15px;

          .item-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
            overflow: hidden;
          }

          .item-index {
            position: absolute;
            width: 30px;
            height: 30px;
            right: 0;
            top: 0;
            transform: translate(50%, -50%);
          }
        }

        .item-name {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 17px;
        }

        .item-num {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 22px;
          margin-bottom: 7px;
        }

        .item-btn-list {
          position: relative;
          z-index: 0;
          display: flex;
          align-items: center;
        }
      }

      .rank-item-0 {
        left: 50%;
        top: 83px;
        transform: translate(-50%, -50%);

        .item-name {
          margin-bottom: 6px;
        }

        .item-avatar {
          margin-bottom: 24px;
        }

        .item-avatar,
        .item-name,
        .item-num {
          transform: scale(1.25);
        }
      }

      .rank-item-1 {
        left: 0%;
        top: 54%;
        transform: translate(0%, -50%);
      }

      .rank-item-2 {
        right: 3px;
        top: 54%;
        transform: translate(0%, -50%);
      }
    }

    .rank-after {
      background: #fff;
      border-radius: 10px;
      position: relative;
      z-index: 2;

      /* height: 490px;
            overflow-y: scroll; */
      .rank-item {
        padding: 13px 0px 10px 12px;
        display: flex;
        align-items: flex-start;

        .item-index {
          margin-top: 8px;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          margin-right: 8px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.2);
        }

        .item-avatar {
          width: 36px;
          height: 36px;
          object-fit: cover;
          border-radius: 6px;
          margin-right: 8px;
        }

        .item-content {
          flex: 1;
          flex-shrink: 0;
          padding-right: 12px;
          overflow: hidden;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e7e7e7;
          padding-bottom: 12px;
          position: relative;
          z-index: 0;
        }

        .item-btn-list {
          position: relative;
          display: flex;
          align-items: center;
        }

        .item-info {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 8px;

          .item-name {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
          }

          .item-num {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #6e4ce6;
            display: flex;
            align-items: center;

            .item-flag {
              line-height: 14px;
              height: 14px;
              background: #ff6a97;
              border-radius: 4px;
              font-size: 9px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ffffff;
              padding: 0px 4px;
              margin-left: 4px;
            }
          }
        }
      }

      .rank-item:last-child {
        .item-content {
          border-bottom: none;
        }
      }
    }

    .item-btn {
      position: relative;
      z-index: 1;
      text-align: center;
      width: 53px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }

    .item-btn-left::before {
      content: '';
      z-index: -1;
      background: #ff6a97;
      border-radius: 6px 0px 0px 6px;
      width: 70%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .item-btn-left::after {
      content: '';
      background: #ff6a97;
      border-radius: 0px 3px 3px 0px;
      width: 40%;
      height: 100%;
      transform: skewX(-20deg);
      position: absolute;
      right: 10%;
      top: 0;
      z-index: -1;
    }

    .item-btn-left {
      margin-right: -8px;
    }

    .item-btn-right::before {
      content: '';
      z-index: -1;
      background: #7757e7;
      border-radius: 0px 6px 6px 0px;
      width: 70%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-btn-right::after {
      content: '';
      background: #7757e7;
      border-radius: 3px 0px 0px 3px;
      width: 40%;
      height: 100%;
      transform: skewX(-20deg);
      position: absolute;
      left: 10%;
      top: 0;
      z-index: -1;
    }
  }

  .desc-container {
    padding: 0px 15px;
    margin-bottom: 18px;

    .text1 {
      font-size: 14px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .text2 {
      font-size: 18px;
      font-family: MiSans, MiSans;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;

      .pink {
        font-family: '';
        font-weight: bold;
        color: rgba(255, 106, 151, 1);
      }
    }
  }

  .dynamic-content {
    .title {
      text-indent: 15px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }

    .dynamic-item-container {
      position: relative;
    }
  }
}
</style>
